module.exports = __webpack_public_path__ + "img/SI.80459a4a.svg";